/* tslint:disable */
/* eslint-disable */
/**
 * Seamworks API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetPermissionListResultDto } from '../model/';
// @ts-ignore
import type { GetResourcePermissionDefinitionListResultDto } from '../model/';
// @ts-ignore
import type { GetResourcePermissionListResultDto } from '../model/';
// @ts-ignore
import type { GetResourcePermissionWithProviderListResultDto } from '../model/';
// @ts-ignore
import type { GetResourceProviderListResultDto } from '../model/';
// @ts-ignore
import type { RemoteServiceErrorResponse } from '../model/';
// @ts-ignore
import type { SearchProviderKeyListResultDto } from '../model/';
// @ts-ignore
import type { UpdatePermissionsDto } from '../model/';
// @ts-ignore
import type { UpdateResourcePermissionsDto } from '../model/';
/**
 * PermissionsApi - axios parameter creator
 * @export
 */
export const PermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [groupName] 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsByGroupGet: async (groupName?: string, providerName?: string, providerKey?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permission-management/permissions/by-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (groupName !== undefined) {
                localVarQueryParameter['groupName'] = groupName;
            }

            if (providerName !== undefined) {
                localVarQueryParameter['providerName'] = providerName;
            }

            if (providerKey !== undefined) {
                localVarQueryParameter['providerKey'] = providerKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsGet: async (providerName?: string, providerKey?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permission-management/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (providerName !== undefined) {
                localVarQueryParameter['providerName'] = providerName;
            }

            if (providerKey !== undefined) {
                localVarQueryParameter['providerKey'] = providerKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {UpdatePermissionsDto} [updatePermissionsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsPut: async (providerName?: string, providerKey?: string, updatePermissionsDto?: UpdatePermissionsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permission-management/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (providerName !== undefined) {
                localVarQueryParameter['providerName'] = providerName;
            }

            if (providerKey !== undefined) {
                localVarQueryParameter['providerKey'] = providerKey;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePermissionsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {string} [resourceKey] 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsResourceByProviderGet: async (resourceName?: string, resourceKey?: string, providerName?: string, providerKey?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permission-management/permissions/resource/by-provider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (resourceName !== undefined) {
                localVarQueryParameter['resourceName'] = resourceName;
            }

            if (resourceKey !== undefined) {
                localVarQueryParameter['resourceKey'] = resourceKey;
            }

            if (providerName !== undefined) {
                localVarQueryParameter['providerName'] = providerName;
            }

            if (providerKey !== undefined) {
                localVarQueryParameter['providerKey'] = providerKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsResourceDefinitionsGet: async (resourceName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permission-management/permissions/resource-definitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (resourceName !== undefined) {
                localVarQueryParameter['resourceName'] = resourceName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {string} [resourceKey] 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsResourceDelete: async (resourceName?: string, resourceKey?: string, providerName?: string, providerKey?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permission-management/permissions/resource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (resourceName !== undefined) {
                localVarQueryParameter['resourceName'] = resourceName;
            }

            if (resourceKey !== undefined) {
                localVarQueryParameter['resourceKey'] = resourceKey;
            }

            if (providerName !== undefined) {
                localVarQueryParameter['providerName'] = providerName;
            }

            if (providerKey !== undefined) {
                localVarQueryParameter['providerKey'] = providerKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {string} [resourceKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsResourceGet: async (resourceName?: string, resourceKey?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permission-management/permissions/resource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (resourceName !== undefined) {
                localVarQueryParameter['resourceName'] = resourceName;
            }

            if (resourceKey !== undefined) {
                localVarQueryParameter['resourceKey'] = resourceKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsResourceProviderKeyLookupServicesGet: async (resourceName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permission-management/permissions/resource-provider-key-lookup-services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (resourceName !== undefined) {
                localVarQueryParameter['resourceName'] = resourceName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {string} [resourceKey] 
         * @param {UpdateResourcePermissionsDto} [updateResourcePermissionsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsResourcePut: async (resourceName?: string, resourceKey?: string, updateResourcePermissionsDto?: UpdateResourcePermissionsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permission-management/permissions/resource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (resourceName !== undefined) {
                localVarQueryParameter['resourceName'] = resourceName;
            }

            if (resourceKey !== undefined) {
                localVarQueryParameter['resourceKey'] = resourceKey;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateResourcePermissionsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {string} [serviceName] 
         * @param {string} [filter] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsSearchResourceProviderKeysGet: async (resourceName?: string, serviceName?: string, filter?: string, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permission-management/permissions/search-resource-provider-keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (resourceName !== undefined) {
                localVarQueryParameter['resourceName'] = resourceName;
            }

            if (serviceName !== undefined) {
                localVarQueryParameter['serviceName'] = serviceName;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PermissionsApi - functional programming interface
 * @export
 */
export const PermissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [groupName] 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPermissionManagementPermissionsByGroupGet(groupName?: string, providerName?: string, providerKey?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPermissionListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPermissionManagementPermissionsByGroupGet(groupName, providerName, providerKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.apiPermissionManagementPermissionsByGroupGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPermissionManagementPermissionsGet(providerName?: string, providerKey?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPermissionListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPermissionManagementPermissionsGet(providerName, providerKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.apiPermissionManagementPermissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {UpdatePermissionsDto} [updatePermissionsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPermissionManagementPermissionsPut(providerName?: string, providerKey?: string, updatePermissionsDto?: UpdatePermissionsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPermissionManagementPermissionsPut(providerName, providerKey, updatePermissionsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.apiPermissionManagementPermissionsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {string} [resourceKey] 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPermissionManagementPermissionsResourceByProviderGet(resourceName?: string, resourceKey?: string, providerName?: string, providerKey?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetResourcePermissionWithProviderListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPermissionManagementPermissionsResourceByProviderGet(resourceName, resourceKey, providerName, providerKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.apiPermissionManagementPermissionsResourceByProviderGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPermissionManagementPermissionsResourceDefinitionsGet(resourceName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetResourcePermissionDefinitionListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPermissionManagementPermissionsResourceDefinitionsGet(resourceName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.apiPermissionManagementPermissionsResourceDefinitionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {string} [resourceKey] 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPermissionManagementPermissionsResourceDelete(resourceName?: string, resourceKey?: string, providerName?: string, providerKey?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPermissionManagementPermissionsResourceDelete(resourceName, resourceKey, providerName, providerKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.apiPermissionManagementPermissionsResourceDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {string} [resourceKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPermissionManagementPermissionsResourceGet(resourceName?: string, resourceKey?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetResourcePermissionListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPermissionManagementPermissionsResourceGet(resourceName, resourceKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.apiPermissionManagementPermissionsResourceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPermissionManagementPermissionsResourceProviderKeyLookupServicesGet(resourceName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetResourceProviderListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPermissionManagementPermissionsResourceProviderKeyLookupServicesGet(resourceName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.apiPermissionManagementPermissionsResourceProviderKeyLookupServicesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {string} [resourceKey] 
         * @param {UpdateResourcePermissionsDto} [updateResourcePermissionsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPermissionManagementPermissionsResourcePut(resourceName?: string, resourceKey?: string, updateResourcePermissionsDto?: UpdateResourcePermissionsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPermissionManagementPermissionsResourcePut(resourceName, resourceKey, updateResourcePermissionsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.apiPermissionManagementPermissionsResourcePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {string} [serviceName] 
         * @param {string} [filter] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPermissionManagementPermissionsSearchResourceProviderKeysGet(resourceName?: string, serviceName?: string, filter?: string, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchProviderKeyListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPermissionManagementPermissionsSearchResourceProviderKeysGet(resourceName, serviceName, filter, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.apiPermissionManagementPermissionsSearchResourceProviderKeysGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PermissionsApi - factory interface
 * @export
 */
export const PermissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PermissionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [groupName] 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsByGroupGet(groupName?: string, providerName?: string, providerKey?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPermissionListResultDto> {
            return localVarFp.apiPermissionManagementPermissionsByGroupGet(groupName, providerName, providerKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsGet(providerName?: string, providerKey?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPermissionListResultDto> {
            return localVarFp.apiPermissionManagementPermissionsGet(providerName, providerKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {UpdatePermissionsDto} [updatePermissionsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsPut(providerName?: string, providerKey?: string, updatePermissionsDto?: UpdatePermissionsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiPermissionManagementPermissionsPut(providerName, providerKey, updatePermissionsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {string} [resourceKey] 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsResourceByProviderGet(resourceName?: string, resourceKey?: string, providerName?: string, providerKey?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetResourcePermissionWithProviderListResultDto> {
            return localVarFp.apiPermissionManagementPermissionsResourceByProviderGet(resourceName, resourceKey, providerName, providerKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsResourceDefinitionsGet(resourceName?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetResourcePermissionDefinitionListResultDto> {
            return localVarFp.apiPermissionManagementPermissionsResourceDefinitionsGet(resourceName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {string} [resourceKey] 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsResourceDelete(resourceName?: string, resourceKey?: string, providerName?: string, providerKey?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiPermissionManagementPermissionsResourceDelete(resourceName, resourceKey, providerName, providerKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {string} [resourceKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsResourceGet(resourceName?: string, resourceKey?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetResourcePermissionListResultDto> {
            return localVarFp.apiPermissionManagementPermissionsResourceGet(resourceName, resourceKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsResourceProviderKeyLookupServicesGet(resourceName?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetResourceProviderListResultDto> {
            return localVarFp.apiPermissionManagementPermissionsResourceProviderKeyLookupServicesGet(resourceName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {string} [resourceKey] 
         * @param {UpdateResourcePermissionsDto} [updateResourcePermissionsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsResourcePut(resourceName?: string, resourceKey?: string, updateResourcePermissionsDto?: UpdateResourcePermissionsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiPermissionManagementPermissionsResourcePut(resourceName, resourceKey, updateResourcePermissionsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [resourceName] 
         * @param {string} [serviceName] 
         * @param {string} [filter] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsSearchResourceProviderKeysGet(resourceName?: string, serviceName?: string, filter?: string, page?: number, options?: RawAxiosRequestConfig): AxiosPromise<SearchProviderKeyListResultDto> {
            return localVarFp.apiPermissionManagementPermissionsSearchResourceProviderKeysGet(resourceName, serviceName, filter, page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
export class PermissionsApi extends BaseAPI {
    /**
     * 
     * @param {string} [groupName] 
     * @param {string} [providerName] 
     * @param {string} [providerKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public apiPermissionManagementPermissionsByGroupGet(groupName?: string, providerName?: string, providerKey?: string, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).apiPermissionManagementPermissionsByGroupGet(groupName, providerName, providerKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [providerName] 
     * @param {string} [providerKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public apiPermissionManagementPermissionsGet(providerName?: string, providerKey?: string, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).apiPermissionManagementPermissionsGet(providerName, providerKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [providerName] 
     * @param {string} [providerKey] 
     * @param {UpdatePermissionsDto} [updatePermissionsDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public apiPermissionManagementPermissionsPut(providerName?: string, providerKey?: string, updatePermissionsDto?: UpdatePermissionsDto, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).apiPermissionManagementPermissionsPut(providerName, providerKey, updatePermissionsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [resourceName] 
     * @param {string} [resourceKey] 
     * @param {string} [providerName] 
     * @param {string} [providerKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public apiPermissionManagementPermissionsResourceByProviderGet(resourceName?: string, resourceKey?: string, providerName?: string, providerKey?: string, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).apiPermissionManagementPermissionsResourceByProviderGet(resourceName, resourceKey, providerName, providerKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [resourceName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public apiPermissionManagementPermissionsResourceDefinitionsGet(resourceName?: string, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).apiPermissionManagementPermissionsResourceDefinitionsGet(resourceName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [resourceName] 
     * @param {string} [resourceKey] 
     * @param {string} [providerName] 
     * @param {string} [providerKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public apiPermissionManagementPermissionsResourceDelete(resourceName?: string, resourceKey?: string, providerName?: string, providerKey?: string, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).apiPermissionManagementPermissionsResourceDelete(resourceName, resourceKey, providerName, providerKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [resourceName] 
     * @param {string} [resourceKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public apiPermissionManagementPermissionsResourceGet(resourceName?: string, resourceKey?: string, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).apiPermissionManagementPermissionsResourceGet(resourceName, resourceKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [resourceName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public apiPermissionManagementPermissionsResourceProviderKeyLookupServicesGet(resourceName?: string, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).apiPermissionManagementPermissionsResourceProviderKeyLookupServicesGet(resourceName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [resourceName] 
     * @param {string} [resourceKey] 
     * @param {UpdateResourcePermissionsDto} [updateResourcePermissionsDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public apiPermissionManagementPermissionsResourcePut(resourceName?: string, resourceKey?: string, updateResourcePermissionsDto?: UpdateResourcePermissionsDto, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).apiPermissionManagementPermissionsResourcePut(resourceName, resourceKey, updateResourcePermissionsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [resourceName] 
     * @param {string} [serviceName] 
     * @param {string} [filter] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public apiPermissionManagementPermissionsSearchResourceProviderKeysGet(resourceName?: string, serviceName?: string, filter?: string, page?: number, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).apiPermissionManagementPermissionsSearchResourceProviderKeysGet(resourceName, serviceName, filter, page, options).then((request) => request(this.axios, this.basePath));
    }
}

